module.exports = __webpack_public_path__ + "img/9.3050a42a.png";